import { GenIcon } from 'react-icons';
export const MdCloseFilled = GenIcon({
    tag: 'svg',
    attr: { fill: 'none' },
    child: [
        {
            tag: 'svg',
            attr: { fill: 'none' },
            child: [
                {
                    tag: 'rect',
                    attr: {
                        fillRule: 'evenodd',
                        clipRule: 'evenodd',
                        fill: 'currentColor',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        fillRule: 'evenodd',
                        clipRule: 'evenodd',
                        d: 'M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM8.53027 7.46973C8.23738 7.17683 7.76262 7.17683 7.46973 7.46973C7.17683 7.76262 7.17683 8.23738 7.46973 8.53027L10.9395 12L7.46973 15.4697C7.17683 15.7626 7.17683 16.2374 7.46973 16.5303C7.76262 16.8232 8.23738 16.8232 8.53027 16.5303L12 13.0605L15.4697 16.5303C15.7626 16.8232 16.2374 16.8232 16.5303 16.5303C16.8232 16.2374 16.8232 15.7626 16.5303 15.4697L8.53027 7.46973ZM16.5303 7.46973C16.2374 7.17683 15.7626 7.17683 15.4697 7.46973L13.4697 9.46973C13.1768 9.76262 13.1768 10.2374 13.4697 10.5303C13.7626 10.8232 14.2374 10.8232 14.5303 10.5303L16.5303 8.53027C16.8232 8.23738 16.8232 7.76262 16.5303 7.46973Z',
                        fill: 'currentColor',
                    },
                    child: [],
                },
            ],
        },
    ],
});
